import React from "react";

import MessageAuthor, { MessageAuthorArgs } from "./MessageAuthor";
import MessageText from "./MessageText";
import { createAttachmentQuoteText } from "helpers/chat/attachmentUtils";
import { AttachmentType } from "components/chat/ChatRoom/ChatMessage/index";

type QuotedMessageArgs = {
  from: MessageAuthorArgs;
  text: string | null;
  files?: AttachmentType[];
  images?: AttachmentType[];
};

export default function QuotedMessage({
  from,
  text,
  files,
  images,
}: QuotedMessageArgs) {
  return (
    <div className="chat__quote rounded">
      <MessageAuthor id={from.id} name={from.name} />
      <MessageText
        text={text || createAttachmentQuoteText({ files, images })}
      />
    </div>
  );
}
